import { create } from 'zustand';

export interface LevelUpMoment {
  id: string;
  /** The level just reached. */
  level: number;
  /** Lifetime earnings (mPXC) that reach the next one; null at the top of the ladder. */
  nextLevelAtMpxc: number | null;
}

interface LevelUpState {
  current: LevelUpMoment | null;
  show(input: Omit<LevelUpMoment, 'id'>): void;
  dismiss(): void;
}

/**
 * The level-up: the miner's jump, over every screen, once per level reached.
 *
 * One at a time. A second level reached while the first is still on screen
 * (a big claim crossing two lines) replaces it: the jump is for where the
 * player stands now, not a queue of where they stood.
 */
export const useLevelUpStore = create<LevelUpState>((set) => ({
  current: null,
  show: (input) => set({ current: { id: `lv-${Date.now()}-${input.level}`, ...input } }),
  dismiss: () => set({ current: null }),
}));
